module.exports = __webpack_public_path__ + "static/media/winterbilanz.e1ca759f.webm";